export default "__VITE_ASSET__ZzZjqEPS__"